import { Loader } from '@/components'
import { paths } from '@/routes/paths'
import {
  useFinishTinkConnection,
  useGetTinkConnections,
} from '@/services/integrations'
import { useGoToPath } from '@/utils'
import { useEffect } from 'react'
import { Container } from './styles'

export const IntegrationsRedirect = () => {
  const { data: connections } = useGetTinkConnections()
  const finishTinkConnectionMutation = useFinishTinkConnection()
  const locationId = connections?.connections?.[0]?.metadata?.locationId
  const source = connections?.connections?.[0]?.source
  const goToIntegrations = useGoToPath(
    paths.integrations,
    {},
    {
      bankingIntegrationsSuccess: true,
    },
  )
  const goToYearlyCheck = useGoToPath(
    paths.viewYearlyCheckWithKey(locationId || ''),
    { withIntegrations: true },
    { bankingIntegrationsSuccess: true },
  )

  const redirectUser = () => {
    if (source === 'yearly-check-in') {
      goToYearlyCheck()
    } else if (source === 'profile-integrations') {
      goToIntegrations()
    } else {
      goToIntegrations()
    }
  }

  useEffect(() => {
    if (connections?.connections?.length) {
      finishTinkConnectionMutation
        .mutateAsync()
        .then(() => {
          redirectUser()
        })
        .catch(() => {
          redirectUser()
        })
    }
  }, [connections])

  return (
    <Container>
      <Loader />
    </Container>
  )
}
